<template>
    <div class="row">
        <div v-if="votingDetail" class="col">
            <div class="row">
                <ToolVotingDetailView v-if="isToolVotingDetail" :detail="votingDetail"/>
                <QuestionVotingDetailView v-else :detail="votingDetail" />
            </div>

            <div class="row justify-content-center mt-4">
                <div class="col-6 text-right">Voting status:</div>
                <div class="col-6">{{votingDetail.getStatusAsString()}}</div>
            </div>

            <div class="row justify-content-center">
                <div class="col-6 text-right">Votes:</div>
                <ul class="col-6">
                    <li v-if="votingDetail.votes.agree !== undefined" class="text-success">{{votingDetail.votes.agree}} Agree</li>
                    <li v-if="votingDetail.votes.disagree !== undefined" class="text-danger">{{votingDetail.votes.disagree}} Disagree</li>
                    <li v-if="votingDetail.votes.abstain !== undefined" class="text-warning">{{votingDetail.votes.abstain}} Abstain</li>
                    <li v-if="votingDetail.votes.ignored !== undefined" class="text-secondary">{{votingDetail.votes.ignored}} Ignored</li>
                </ul>
            </div>

            <div v-if="canVote" class="row justify-content-center mt-4">
                <div class="col">
                    <div class="row justify-content-center">
                        <div class="col-6 text-right">Your vote:</div>

                        <div class="col-6 d-flex justify-content-start">
                            <div class="custom-control custom-radio custom-control-inline">
                                <input type="radio" id="vote-yes" name="vote" class="custom-control-input" v-model="userVote" value="agree">
                                <label class="custom-control-label" for="vote-yes"><strong>Yes</strong></label>
                            </div>

                            <div class="custom-control custom-radio custom-control-inline">
                                <input type="radio" id="vote-no" name="vote" class="custom-control-input" v-model="userVote" value="disagree">
                                <label class="custom-control-label" for="vote-no"><strong>No</strong></label>
                            </div>

                            <div v-if="isToolVotingDetail === false" class="custom-control custom-radio custom-control-inline">
                                <input type="radio" id="vote-abstain" name="vote" class="custom-control-input" v-model="userVote" value="abstain">
                                <label class="custom-control-label" for="vote-abstain"><strong>Abstain</strong></label>
                            </div>
                        </div>
                    </div>

                    <div class="row justify-content-center mt-3">
                        <div class="col">
                            <app-submit-button :btnClass="'d-block mx-auto'" :submitAction="submitUserVote" :caption="'Submit'" />
                        </div>
                    </div>
                </div>
            </div>

            <div v-else class="row justify-content-center mt-3">
                <div class="col-6 text-right">Your vote:</div>
                <div class="col-6">{{votingDetail.getCurrentVoteAsString()}}</div>
            </div>
        </div>
    </div>


</template>

<script lang="ts">
    import {Component, Vue} from "vue-property-decorator";
    import {HttpHandler} from "@/http/HttpHandler";
    import {ToolVotingDetail} from "@/entities/voting/ToolVotingDetail";
    import {QuestionVotingDetail} from "@/entities/voting/QuestionVotingDetail";
    import ToolVotingDetailView from "@/views/expert/voting/ToolVotingDetailView.vue";
    import QuestionVotingDetailView from "@/views/expert/voting/QuestionVotingDetailView.vue";
    import {VotesType} from "@/entities/voting/VotesType";
    import AppSubmitButton from "@/components/AppSubmitButton.vue";
    import store from "@/store/index";

    @Component({
        components: {
            ToolVotingDetailView,
            QuestionVotingDetailView,
            AppSubmitButton,
        },
    })
    export default class VotingDetail extends Vue {
        private votingId: number = 0;
        private votingDetail: ToolVotingDetail | QuestionVotingDetail | null = null;
        private userVote: VotesType = VotesType.ignored;

        get isToolVotingDetail(): boolean {
            return this.votingDetail instanceof ToolVotingDetail;
        }

        get canVote(): boolean {
            return this.votingDetail == null ? false : this.votingDetail.canVote();
        }

        async submitUserVote() {
            let httpHandler = new HttpHandler(store);
            await httpHandler.postUserVoteByVotingId(this.votingId, this.userVote);
            this.votingDetail = await httpHandler.getVotingDetailById(this.votingId);
        }

        async created() {
            if(this.$route.params.id == null || isNaN(Number(this.$route.params.id))) {
                await this.$router.push('/voting');
                return;
            }

            this.votingId = +this.$route.params.id;
            const httpHandler = new HttpHandler(store);
            this.votingDetail = await httpHandler.getVotingDetailById(this.votingId);
        }
    }
</script>

<style scoped lang="scss">
    @import "node_modules/bootstrap/scss/_functions.scss";
    @import "node_modules/bootstrap/scss/_variables.scss";
    @import "node_modules/bootstrap/scss/_mixins.scss";

    @include media-breakpoint-down(md) {
        .disease-param {
            &__name {
                text-align: right;
            }
        }
    }

    ul {
        list-style: none;
    }
</style>
